import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  claim_type: fromDatatype.VarcharDatatypeInterface;
  claim_item_category_01_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_02_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_03_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_04_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_05_guid: fromDatatype.GuidDataFieldInterface;
  max_txn_period_in_months: fromDatatype.IntegerDatatypeInterface;
  max_txn_period_in_days: fromDatatype.IntegerDatatypeInterface;
  require_supporting_document: boolean;
  billing_to_customer: boolean;
  billing_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  billing_markup_ratio: fromDatatype.IntegerDatatypeInterface;
  expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  threshold: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  claim_item_category: fromDatatype.VarcharDatatypeInterface;
  require_vendor_receipt_date_and_receipt_number: boolean;
  require_date_range: boolean;
  require_following_up: boolean;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  sending_attachments_to_ocr: boolean;
  require_ocr: boolean;
  require_membership: boolean;
  org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  required_professional_body: boolean;
  require_travel_allowance: boolean;
  item_remarks_template: fromDatatype.TextDatatypeInterface;
  is_prorated_for_new_employees: boolean;
  require_internal_employees: boolean;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  require_location_tracking: boolean;
  is_mileage_claim: boolean;
  required_custom_validity_date_hr: boolean;
  billing_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  billing_txn_glname: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glname: fromDatatype.VarcharDatatypeInterface;
  payment_processing_option: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_item_hdr_RowClass implements bl_aat_claim_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  claim_type: fromDatatype.VarcharDatatypeInterface;
  claim_item_category_01_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_02_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_03_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_04_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_05_guid: fromDatatype.GuidDataFieldInterface;
  max_txn_period_in_months: fromDatatype.IntegerDatatypeInterface;
  max_txn_period_in_days: fromDatatype.IntegerDatatypeInterface;
  require_supporting_document: boolean;
  billing_to_customer: boolean;
  billing_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  billing_markup_ratio: fromDatatype.IntegerDatatypeInterface;
  expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  threshold: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  claim_item_category: fromDatatype.VarcharDatatypeInterface;
  require_vendor_receipt_date_and_receipt_number: boolean;
  require_date_range: boolean;
  require_following_up: boolean;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  sending_attachments_to_ocr: boolean;
  require_ocr: boolean;
  require_membership: boolean;
  org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  required_professional_body: boolean;
  require_travel_allowance: boolean;
  item_remarks_template: fromDatatype.TextDatatypeInterface;
  is_prorated_for_new_employees: boolean;
  require_internal_employees: boolean;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  require_location_tracking: boolean;
  is_mileage_claim: boolean;
  required_custom_validity_date_hr: boolean;
  billing_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  billing_txn_glname: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glname: fromDatatype.VarcharDatatypeInterface;
  payment_processing_option: fromDatatype.VarcharDatatypeInterface;
}
